import { render } from "./policy.vue?vue&type=template&id=0ccf4e80&scoped=true"
import script from "./policy.vue?vue&type=script&lang=js"
export * from "./policy.vue?vue&type=script&lang=js"

import "./policy.vue?vue&type=style&index=0&id=0ccf4e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccf4e80"]])

export default __exports__